export default (that) => [
  {
    title: '#',
    field: 'indexSeq',
    width: 80,
    align: 'center',
    fixed: 'left',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 110,
    slots: {
      default: 'opt',
    },
  },
  {
    title: that.$l('form_label_PID') || '上级功能编号',
    field: 'pid',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_funcID') || '功能编号',
    field: 'funcID',
    width: 200,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      header: 'funcID',
    },
  },
  {
    title: that.$l('form_label_classLevel') || '功能层级',
    field: 'classLevel',
    width: 150,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      header: 'classLevel',
    },
  },
  {
    title: that.$l('form_label_titleText') || '功能标题',
    field: 'titleText',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      header: 'titleText',
    },
  },
  {
    title: that.$l('form_label_funcIcon') || '功能图标名称',
    field: 'funcIcon',
    width: 110,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'icon',
    },
  },
  {
    title: that.$l('form_label_menuWebPageUrl') || '页面URL地址',
    field: 'menuWebPageUrl',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_sortOrder') || '功能排列顺序',
    field: 'sortOrder',
    width: 110,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_isLast') || '是否末级',
    field: 'isLast',
    width: 150,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'isLast',
    },
  },
  {
    title: that.$l('form_label_isVisible') || '是否可见',
    field: 'isVisible',
    width: 110,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'isVisible',
    },
  },
  {
    title: that.$l('form_label_descText') || '功能描述',
    field: 'descText',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },

  {
    title: that.$l('form_label_appName') || '所属应用',
    field: 'appName',
    width: 110,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_formType') || '页面类型',
    field: 'formType',
    width: 110,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'creationTime',
    title: that.$l('INDEX.create_date') || '创建时间',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  }
]
